import posthog from 'posthog-js'
const { ENVIRONMENT } = process.env;

export const initPostHog = (REACT_APP_POSTHOG_API_KEY, REACT_APP_POSTHOG_HOST) => {
    if (!REACT_APP_POSTHOG_API_KEY || !REACT_APP_POSTHOG_HOST) {
        console.warn('PostHog API key or host is not provided');
        return;
    }

    posthog.init(REACT_APP_POSTHOG_API_KEY, {
        api_host: REACT_APP_POSTHOG_HOST,
        loaded: (posthog) => {

            // Register common properties for all events
            posthog.register({
                environment: ENVIRONMENT,
                service: 'admin-react',
            })

            if(process.env.NODE_ENV !== 'production') {
                console.log('PostHog initialized:', posthog)
            }
            else {
                posthog.opt_in_capturing()
                posthog.capture('PostHog initialized')
            }
        },
        capture_pageview: true,
        capture_exceptions: true,
        capture_dead_clicks: true,
        autocapture: true,
        capture_heatmaps: true,
        capture_performance: true,
        session_recording: {
            maskAllInputs: true,
            sampleRate: 0.3
        }
    })
}

export const identifyPostHogUser = (email, userProperties = {}) => {
    if (posthog && email) {
        posthog.identify(email, {
            ...userProperties
        })
    }
}

export const capturePostHogEvent = (eventName, eventProperties = {}) => {
    if (posthog && eventName) {
        posthog.capture(eventName, eventProperties)
    }
}